module.exports = __webpack_public_path__ + "media/images/business/cards/technology-d0591babd2b83b674fd65cfeec81dcfe.png";